import { MSConstant } from '@/commons/wildcards/index.js';
import store from '@/stores/store';
import { ModuleDbOption } from '@/stores/moduleConst';
const state = {
  superiorSourceSelected: [], // Những nguồn kinh phí cấp trên
  fileUploads: [], // Dữ liệu file đính kèm
  dataStepOne: {
    // Dữ liệu bước 1
    gridInfoReportSelected: [], // Các báo cáo được chọn ở bước 1
    gridInfoMoneySelected: [], // Các nguồn kinh phí được chọn
    gridInfoReportData: [], // Dữ liệu các báo cáo ở bước 1
    period: 101, // Quý này
    periodText: 'Quý I', // Kỳ báo cáo - Text
    year: new Date().getFullYear(), //Năm
    isCheckBoxForStepOne: false, //Checkbox "Bao gồm số liệu..."
    isFundIncludedSalaryReformAmount: false, // checkbox Số kinh phí sử dụng bao gồm số trích lập Cải cách tiên lương
    report_id: 1, // Dữ liệu combo Chọn Bộ BCTC
    report_name: 'Báo cáo tài chính theo TT 107/2017/TT-BTC (Lưu chuyển tiền tệ theo phương pháp gián tiếp)', // Dữ liệu combo Chọn Bộ BCTC
    postedYear: new Date().getFullYear(),
    isC03CCTTNoData: null, // Báo cáo C03/CCTT đã được lập hay trưa
    isCheckBoxRealityAriseForStepOne: false, //Checkbox "Số dự toán năm lấy theo thực tết phát sinh"
  },
  dataStepThree: {
    errorsC03ToBTCT01: [], // Chỉ tiêu lỗi BTCT01 so sách C03
    errorsC03ToBTCT04: [], // Chỉ tiêu lỗi BTCT04 so sách C03
    errorsFinancial: [], // Báo cáo tài chính
    errorsSettlement: [], // Báo cáo quyết toán
  },
  budgetSourceDictionary: [], // Danh mục nguồn của cấp trên Lekima
};

const getters = {
  /**
   * Lấy dữ liệu nguồn kinh phí cấp trên
   */
  superiorSourceSelected(state) {
    return state.superiorSourceSelected;
  },

  /**
   *  lấy dữ liệu file đính kèm
   */
  fileUploads(state) {
    return state.fileUploads;
  },

  gridInfoReportSelected(state) {
    if (state.dataStepOne.gridInfoReportSelected?.length == 0) return state.dataStepOne.gridInfoReportSelected;
    let dbOptions = store.state[ModuleDbOption]?.dbOptions;
    var data = state.dataStepOne.gridInfoReportSelected.filter(
      x =>
        x.bctc_ids.includes(state.dataStepOne.report_id) &&
        (!x.particularity || (x.particularity && x.particularity == dbOptions.Particularity))
    );
    if (state.dataStepOne.period != MSConstant.ReportPeriod.Year || state.dataStepOne.isC03CCTTNoData) {
      data = data?.filter(x => x.report_id != 'C03/CCTT');
      if (state.dataStepOne.period != MSConstant.ReportPeriod.Year) {
        data = data?.filter(x => x.report_id != 'SummaryReceipt_M02');
      }
    }
    return data;
  },
};

const actions = {};

const mutations = {
  /**
   *
   * @param {*} state
   * Xóa dữ liệu
   */
  clearData(state) {
    let postedDate = store.getters['context/PostedDate'];
    let dbOptions = store.state[ModuleDbOption]?.dbOptions;

    var dataStepOne = {
      gridInfoReportSelected: [],
      gridInfoMoneySelected: [],
      gridInfoReportData: [],
      isCheckBoxForStepOne: false,
      report_id: 1,
      report_name: 'Báo cáo tài chính theo TT 107/2017/TT-BTC (Lưu chuyển tiền tệ theo phương pháp gián tiếp)',
      isC03CCTTNoData: null,
    };
    state.dataStepOne = dataStepOne;

    state.superiorSourceSelected = [];
    state.fileUploads = [];
    // state.budgetSourceDictionary = [];
    var dataStepThree = {
      errorsC03ToBTCT01: [],
      errorsC03ToBTCT04: [],
      errorsFinancial: [],
      errorsSettlement: [],
    };
    state.dataStepThree = dataStepThree;
    var period = {
      period: MSConstant.ReportPeriod.QuarterI,
      periodText: 'Quý I',
    };

    let quarter = Math.floor(new Date().getMonth() / 3) + 1;
    switch (quarter) {
      case 1: {
        period.period = MSConstant.ReportPeriod.QuarterI;
        period.periodText = 'Quý I';
        break;
      }
      case 2: {
        period.period = MSConstant.ReportPeriod.QuarterII;
        period.periodText = 'Quý II';
        break;
      }
      case 3: {
        period.period = MSConstant.ReportPeriod.QuarterIII;
        period.periodText = 'Quý III';
        break;
      }
      case 4: {
        period.period = MSConstant.ReportPeriod.QuarterIV;
        period.periodText = 'Quý IV';
        break;
      }
    }
    state.dataStepOne.period = period.period;
    state.dataStepOne.periodText = period.periodText;

    if (dbOptions?.DBStartDate) {
      state.dataStepOne.postedYear = dbOptions?.DBStartDate.getFullYear();
    }

    if (postedDate) {
      state.dataStepOne.year = postedDate.getFullYear();
      state.dataStepOne.yearText = postedDate.getFullYear().toString();
    }
  },

  /**
   * Cập nhật dữ liệu báo cáo ở bước 1
   * @param {*} state
   * @param {*} data
   */
  updateGridInfoReportData(state, data) {
    state.dataStepOne.gridInfoReportData = data;
  },

  /**
   * Cập nhật kết quả kiểm tra C03
   * @param {*} state
   * @param {*} data
   */
  updateCheckC03(state, data) {
    state.dataStepOne.isC03CCTTNoData = data;
  },

  /**
   * Cập những báo cáo cần nộp lên
   * @param {*} state
   * @param {*} data
   */
  updateGridInfoReportSelected(state, data) {
    state.dataStepOne.gridInfoReportSelected = data;
  },

  /**
   * Cập nhật những nguồn kinh phí được chọn
   * @param {*} state
   * @param {*} data
   */
  updateGridInfoMoneySelected(state, data) {
    state.dataStepOne.gridInfoMoneySelected = data;
  },

  /**
   * Cập nhật năm
   * @param {*} state
   * @param {*} data
   */
  updateYear(state, data) {
    state.dataStepOne.year = data;
    state.dataStepOne.yearText = data.toString();
  },

  /**
   * Cập nhật kỳ báo cáo
   * @param {*} state
   * @param {*} data
   */
  updatePeriod(state, data) {
    state.dataStepOne.period = data.enumValue;
    state.dataStepOne.periodText = data.enumText;
  },

  /**
   * Cập nhật dữ liệu Bộ BCTC
   * @param {*} state
   * @param {*} data
   */
  updateComboboData(state, data) {
    state.dataStepOne.report_id = data.report_id;
    state.dataStepOne.report_name = data.report_name;
  },

  /**
   * Cập nhật dữ liệu checkBox Bao gồm số liệu SXKD
   * @param {*} state
   * @param {*} data
   */
  updateIsCheckBoxForStepOne(state, data) {
    state.dataStepOne.isCheckBoxForStepOne = data;
  },
  /**
   * Cập nhật nguồn kinh phí cấp trên
   * @param {*} state
   * @param {*} data
   */
  updateSuperiorSourceSelected(state, data) {
    state.superiorSourceSelected = data;
  },

  /**
   * Cập nhật tệp đính kèm
   * @param {*} state
   * @param {*} data
   */
  updateFileUploads(state, data) {
    let item = state.fileUploads.find(x => x.FileID === data.FileID);
    if (item) {
      Object.assign(item, data);
    } else {
      state.fileUploads.push(data);

    }
  },
  /**
   * Cập nhật dữ liệu chỉ tiêu lỗi
   * @param {*} state
   * @param {*} data
   */
  updateDataStepThree(state, data) {
    state.dataStepThree.errorsFinancial = data.errorsFinancial;
    state.dataStepThree.errorsSettlement = data.errorsSettlement;
    state.dataStepThree.errorsC03ToC03 = data.errorsC03ToC03;
    state.dataStepThree.errorsC03ToBTCT01 = data.errorsC03ToBTCT01;
    state.dataStepThree.errorsC03ToBTCT04 = data.errorsC03ToBTCT04;
  },

  /**
   * Lưu dữ liệu nguồn của lekima
   * @param {*} state
   * @param {*} data
   */
  setBudgetSourceDictionary(state, data) {
    state.budgetSourceDictionary = data;
  },
  /**
   * Cập nhật dữ liệu checkbox: Số dự toán năm lấy theo thực tết phát sinh
   * @param {*} state 
   * @param {*} data 
   */
  updateIsCheckBoxRealityAriseForStepOne(state, data) {
    state.dataStepOne.isCheckBoxRealityAriseForStepOne = data;
  },

  /**
   * Cập nhật dữ liệu cho checkbox Số kinh phí sử dụng bao gồm số trích lập Cải cách tiên lương
   * 
   * @param {*} state 
   * @param {*} data 
   * DTQUOC 12.03.2024
   */
  updateIsFundIncludedSalaryReformAmount(state, data) {
    state.dataStepOne.isFundIncludedSalaryReformAmount = data;
  }
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
